<template>
  <div class="portal-workspace-loader portal-workspace-error" role="alert">
    <div class="portal-workspace-loader__card">
      <v-icon icon="mdi-alert-circle-outline" size="40" color="error" />
      <p class="portal-workspace-loader__title">Could not load workspace</p>
      <p class="portal-workspace-loader__subtitle">{{ message }}</p>
      <div class="portal-workspace-loader__actions">
        <v-btn
          color="primary"
          variant="flat"
          class="text-none"
          rounded="lg"
          :loading="signingOut"
          :disabled="retrying"
          @click="$emit('logout')"
        >
          Logout
        </v-btn>
        <v-btn
          variant="outlined"
          class="text-none portal-workspace-loader__retry"
          rounded="lg"
          :loading="retrying"
          :disabled="signingOut"
          @click="$emit('retry')"
        >
          Try again
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'PortalWorkspaceError' })

defineProps({
  message: { type: String, default: 'Something went wrong.' },
  retrying: { type: Boolean, default: false },
  signingOut: { type: Boolean, default: false },
})

defineEmits(['logout', 'retry'])
</script>

<style scoped>
.portal-workspace-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background: var(--y-bg, #030712);
  color: var(--y-text, #f8fafc);
}

.portal-workspace-loader__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 360px;
  text-align: center;
}

.portal-workspace-loader__title {
  margin: 8px 0 0;
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.portal-workspace-loader__subtitle {
  margin: 0;
  font-size: 0.875rem;
  color: var(--y-text-muted, rgba(248, 250, 252, 0.65));
  line-height: 1.5;
  word-break: break-word;
}

.portal-workspace-loader__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
  width: 100%;
}

.portal-workspace-loader__retry {
  border-color: rgba(148, 163, 184, 0.35) !important;
  color: var(--y-text-muted, rgba(248, 250, 252, 0.75)) !important;
}
</style>
